import React, { useState } from "react";
import { UseModalType } from "../../../../../utils/custom-hooks";

export const usePdfUploaderModal = (
  updateOutputBasePDFBinary: (
    value: string,
    fileName: string,
  ) => Promise<boolean>,
  uploadPDFModal: UseModalType,
) => {
  const [pdf, setPdf] = useState<string | undefined>();
  const [pdfName, setPdfName] = useState<string | undefined>();

  const onSelectPdf: React.ChangeEventHandler<HTMLInputElement> = ({
    target: { files },
  }) => {
    if (!files || files.length === 0) {
      return;
    }
    const fileReader = new FileReader();
    const fileDropped = files[0];
    fileReader.onload = function () {
      const dataUri = this.result as string;
      setPdf(dataUri.split(",")[1]);
      setPdfName(fileDropped.name);
    };
    fileReader.readAsDataURL(fileDropped);
  };

  const onClickUploadPdfSave = async () => {
    if (!pdf || !pdfName) {
      return;
    }
    const isSaved = await updateOutputBasePDFBinary(pdf, pdfName);
    if (isSaved) {
      uploadPDFModal.close();
    }
  };

  return {
    pdf,
    setPdf,
    pdfName,
    setPdfName,
    onSelectPdf,
    onClickUploadPdfSave,
  };
};
